/* eslint-disable prettier/prettier */
import { playerPaymentProfileStatus } from '@/helpers/ProfileHelpers';
import {
  ProductSourceInfo,
  arrInAppMobile,
} from '@/helpers/ProductSourceHelpers';

// siteUrl: Chemin physiquement défini dans Magnolia (indépendant de la langue)
// protection (MAJ=défaut):
//  productSource:
//    listeAuMoinsUnParmi: [...]|(VIDE)
//    listeAbsent: [...]|(VIDE)
//  estConnecte: true|false|(VIDE)
//  rafraichirProfile: true|FALSE
//  aProfession: true|false|(VIDE)
//  statusFlag:
//    listeObligatoire: [...]|(VIDE)
//    obligatoireExclusif: true|FALSE
//    listeAuMoinsUnParmi: [...]|(VIDE)
//    listeAbsent: [...]|(VIDE)
//  obtenirAdresse: true|FALSE
//  aAdresse: true|false|(VIDE) - obtenirAdresse doit être true
//  obtenirDepotInfo: true|FALSE
//  obtenirRetraitInfo: true|FALSE
//  aLimiteDepot: true|false|(VIDE)

// eslint-disable-next-line import/prefer-default-export
export const PageMapping = {
  // ***** Début de l'inscription *****
  BIENVENUE: {
    siteUrl: '/inscription/bienvenue',
    siteUrlEn: '/registration/welcome',
    protection: { estConnecte: false },
    rafraichirProfile: true,
  },
  COURRIEL: {
    siteUrl: '/inscription/courriel',
    siteUrlEn: '/registration/email',
    protection: { estConnecte: false },
    rafraichirProfile: true,
  },
  PRENOM_ET_NOM: {
    siteUrl: '/inscription/prenom-et-nom',
    protection: { estConnecte: false },
  },
  TELEPHONE: {
    siteUrl: '/inscription/telephone',
    protection: { estConnecte: false },
  },
  INFOS_PERSONNELLES: {
    siteUrl: '/inscription/infos-personnelles',
    siteUrlEn: '/registration/personal-info',
    protection: { estConnecte: false },
    rafraichirProfile: true,
  },
  MOT_DE_PASSE: {
    siteUrl: '/inscription/mot-de-passe',
    protection: { estConnecte: false },
  },
  QUESTION_DE_SECURITE: {
    siteUrl: '/inscription/question-de-securite',
    protection: { estConnecte: false },
  },
  DATE_DE_NAISSANCE: {
    siteUrl: '/inscription/date-de-naissance',
    protection: { estConnecte: false },
  },
  ADRESSE_2E_CHANCE: {
    siteUrl: '/inscription/adresse-2e-chance',
    useSalesforceMigration: true,
  },
  ADRESSE_SUGGESTION_2E_CHANCE: {
    siteUrl: '/inscription/adresse-suggestion-2e-chance',
  },
  OFFRE: {
    siteUrl: '/inscription/offre',
    protection: { estConnecte: false },
  },
  RESTONS_EN_CONTACT: {
    siteUrl: '/inscription/restons-en-contact',
    useSalesforceMigration: true,
  },
  RESTONS_EN_CONTACT_OFFRE: {
    siteUrl: '/inscription/restons-en-contact-offre',
  },
  // ***** Pages création compte parcours 2e chance *****
  COMPTE_BLOQUE_2E_CHANCE: {
    siteUrl: '/inscription/compte-bloque-2e-chance',
    protection: { estConnecte: false },
  },

  COMPTE_DOUBLON_2E_CHANCE: {
    siteUrl: '/inscription/compte-doublon-2e-chance',
    protection: { estConnecte: false },
  },

  TRANSITION: {
    siteUrl: '/inscription/transition',
  },

  COMPTE_CONFIRMATION_2E_CHANCE: {
    siteUrl: '/compte/confirmation-2e-chance',
    protection: {
      estConnecte: true,
      aProfession: false,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  ACTIVITE_JEUX: {
    siteUrl: '/compte/sommaire-de-mes-habitudes-de-jeu',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  MESSAGES_BIENJOUER: {
    siteUrl: '/compte/messages-bien-jouer',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  // ***** Validation d'identité *****
  IDENTITE: {
    siteUrl: '/compte/identite',
    protection: {
      estConnecte: true,
      aProfession: false,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
      },
    },
    forceRefreshSalesforceProfile: true,
  },
  IDENTITE_OFFRE: {
    siteUrl: '/compte/identite-offre',
    protection: {
      estConnecte: true,
      aProfession: false,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  // Pour des raisons de performance, uniquement pour un client "joueur" (non-guest),
  // le micro-service retourne toujours "true" pour "hasProfession".
  // Dans ce cas, la seule façon d'y accéder est d'aller directement sur Profession/Canafe.
  IDENTITE_PROFESSION: {
    siteUrl: '/compte/identite-profession',
    protection: {
      estConnecte: true,
      aProfession: false,
    },
    forceRefreshPlayersProfile: true,
  },
  IDENTITE_QUESTION_LEGISLATION_FEDERALE: {
    siteUrl: '/compte/identite-question-legislation-federale',
    protection: {
      estConnecte: true,
      // Sert uniquement pour empêcher les joueurs sans profession d'accéder cette page en cliquant sur le "précédent" de la page "Explorez nos jeux"
      joueurException: true,
    },
  },

  IDENTITE_OPTIONS_VERIFICATION: {
    siteUrl: '/compte/identite-options-verification',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [
          playerPaymentProfileStatus.UPLOAD_ID,
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
          // playerPaymentProfileStatus.WATCHLIST,
        ],
      },
    },
    forceRefreshSalesforceProfile: true,
    forceRefreshPlayersProfile: true,
  },

  // Validation d'identité (carte de crédit)
  IDENTITE_ADRESSE: {
    siteUrl: '/compte/identite-adresse',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
        listeAbsent: [
          playerPaymentProfileStatus.FAILED_OPTIMAL,
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
          // playerPaymentProfileStatus.WATCHLIST,
        ],
      },
      obtenirAdresse: true,
    },
    forceRefreshPlayersProfile: true,
  },
  IDENTITE_ADRESSE_SUGGESTION: {
    siteUrl: '/compte/identite-adresse-suggestion',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
        listeAbsent: [
          playerPaymentProfileStatus.FAILED_OPTIMAL,
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
          // playerPaymentProfileStatus.WATCHLIST,
        ],
      },
    },
  },
  IDENTITE_CONFIRMATION: {
    siteUrl: '/compte/identite-confirmation',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },
  IDENTITE_CONFIRMATION_JEUX: {
    siteUrl: '/compte/identite-confirmation-jeux',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },
  IDENTITE_ECHEC: {
    siteUrl: '/compte/identite-echec',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
          playerPaymentProfileStatus.UPLOAD_ID,
        ],
      },
    },
    forceRefreshPlayersProfile: true,
  },
  IDENTITE_ECHEC_DOUBLON: {
    siteUrl: '/compte/identite-echec-doublon',
  },
  IDENTITE_ECHEC_AUTOEXCLUSION: {
    siteUrl: '/compte/identite-echec-autoexclusion',
  },

  // Validation d'identité (documents)
  IDENTITE_DOCUMENTS: {
    siteUrl: '/compte/identite-documents',
    protection: {
      productSource: {
        listeAbsent: arrInAppMobile,
      },
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [playerPaymentProfileStatus.UPLOAD_ID],
      },
    },
  },
  IDENTITE_DOCUMENT_ADRESSE: {
    siteUrl: '/compte/identite-documents-adresse',
    protection: {
      productSource: {
        listeAbsent: arrInAppMobile,
      },
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [playerPaymentProfileStatus.UPLOAD_ID],
      },
      obtenirAdresse: true,
    },
  },
  IDENTITE_DOCUMENT_ADRESSE_SUGGESTION: {
    siteUrl: '/compte/identite-documents-adresse-suggestion',
    protection: {
      productSource: {
        listeAbsent: arrInAppMobile,
      },
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,

          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [playerPaymentProfileStatus.UPLOAD_ID],
      },
    },
  },
  IDENTITE_DOCUMENT_TELEVERSEMENT: {
    siteUrl: '/compte/identite-documents-televersement',
    protection: {
      productSource: {
        listeAbsent: arrInAppMobile,
      },
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [playerPaymentProfileStatus.UPLOAD_ID],
      },
      obtenirAdresse: true,
      aAdresse: true,
    },
    forceRefreshSalesforceProfile: true,
  },

  IDENTITE_DOCUMENTS_CONFIRMATION: {
    siteUrl: '/compte/identite-documents-confirmation',
    protection: {
      productSource: {
        listeAbsent: arrInAppMobile,
      },
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAuMoinsUnParmi: [
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.UPLOAD_ID,
        ],
      },
      rafraichirProfile: true,
    },
  },
  IDENTITE_DOCUMENTS_ENVOYES: {
    siteUrl: '/compte/identite-documents-envoyes',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          // playerPaymentProfileStatus.FAILED_OPTIMAL,
          // playerPaymentProfileStatus.UPLOAD_ID,
        ],
        listeAuMoinsUnParmi: [
          playerPaymentProfileStatus.FAILED_OPTIMAL,
          playerPaymentProfileStatus.UPLOAD_ID,
        ],
      },
    },
  },
  IDENTITE_DOCUMENTS_ENVOYES_SERVICE: {
    siteUrl: '/compte/identite-documents-envoyes-service',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.UPLOAD_ID,
        ],
        listeAbsent: [
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
        ],
      },
    },
    forceRefreshPlayersProfile: true,
  },

  IDENTITE_SERVICE_VALIDATION: {
    siteUrl: '/compte/identite-service-validation',
    siteUrlEn: '/account/identity-service-confirmation',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,
          playerPaymentProfileStatus.FAILED_OPTIMAL,
        ],
        listeAbsent: [
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
          playerPaymentProfileStatus.PENDING_ID_VERIFIEDME,
        ],
      },
    },
  },

  IDENTITE_SERVICE_ECHEC: {
    siteUrl: '/compte/identite-service-echec',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [
          playerPaymentProfileStatus.GUEST,

          playerPaymentProfileStatus.FAILED_OPTIMAL,
          playerPaymentProfileStatus.FAILED_VERIFIEDME,
        ],
      },
      rafraichirProfile: true,
    },
  },

  // Reprise
  // identite-reprise est le point d'entrée pour aiguiller le consommateur
  IDENTITE_REPRISE: {
    siteUrl: '/compte/identite-reprise',
    protection: {
      estConnecte: true,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
        obligatoireExclusif: true,
      },
      rafraichirProfile: true,
    },
    forceRefreshSalesforceProfile: true,
    useSalesforceMigration: true,
  },
  IDENTITE_REPRISE_DOCUMENTS: {
    siteUrl: '/compte/identite-reprise-documents',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
        listeAbsent: [playerPaymentProfileStatus.UPLOAD_ID],
      },
    },
    useSalesforceMigration: true,
    forceRefreshPlayersProfile: true,
  },
  IDENTITE_REPRISE_ECHEC_APP: {
    siteUrl: '/compte/identite-reprise-echec-app',
    siteUrlEn: '/account/identity-retry-failure-app',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeObligatoire: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  // **** Encadrer mon jeux ****
  LIMITE_DE_JEU: {
    siteUrl: '/compte/limites-de-jeu',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },
  // ***** Dépôt *****
  LIMITE_DEPOT: {
    siteUrl: '/compte/limite-depot',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      aLimiteDepot: false,
    },
  },
  LIMITE_DEPOT_CHOIX: {
    siteUrl: '/compte/limite-depot-choix',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      aLimiteDepot: false,
    },
  },
  DEPOT: {
    siteUrl: '/compte/depot',
    siteUrlEn: '/account/deposit',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      sansChargementProfil: true,
    },
  },
  DEPOT_NON_AUTORISE: {
    siteUrl: '/compte/depot-non-autorise',
    protection: {
      estConnecte: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },
  DEPOT_CONFIRMATION: {
    siteUrl: '/compte/depot-confirmation',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      obtenirDepotInfo: true,
      aLimiteDepot: true,
    },
  },
  DEPOT_ARGENT_WEB_NON_AUTORISE: {
    siteUrl: '/compte/depot-argent-web-non-autorise',
    protection: {
      estConnecte: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },
  DEPOT_PAIEMENT_FACTURE: {
    siteUrl: '/compte/depot-paiement-facture',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      obtenirDepotInfo: true,
      aLimiteDepot: true,
    },
  },
  // ***** Retrait *****
  RETRAIT: {
    siteUrl: '/compte/retraits',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
      obtenirRetraitInfo: true,
    },
  },

  // ***** Connexion *****
  CONNEXION: {
    siteUrl: '/connexion',
    protection: { estConnecte: false },
  },

  // ***** Erreurs *****
  ERREUR_GENERIQUE: {
    siteUrl: '/erreur/generique',
  },
  ERREUR_INSCRIPTION: {
    siteUrl: '/erreur/inscription',
  },
  ERREUR_CONNEXION: {
    siteUrl: '/erreur/connexion',
    protection: {
      estConnecte: false,
    },
  },
  ERREUR_IDENTITE_PROFESSION: {
    siteUrl: '/erreur/identite-profession',
    protection: {
      estConnecte: true,
      aProfession: false,
    },
  },
  ERREUR_IDENTITE_ADRESSE: {
    siteUrl: '/erreur/identite-adresse',
    protection: {
      estConnecte: true,
    },
  },
  ERREUR_DEPOT_CARTE: {
    siteUrl: '/erreur/depot-carte',
    protection: {
      estConnecte: true,
    },
  },
  ERREUR_ENVOI_REQUETE: {
    siteUrl: '/erreur/envoi-requete',
  },
  ERREUR_CONFIRMATION_CANAFE: {
    siteUrl: '/erreur/mise-a-jour-informations-personnelles',
    protection: {
      estConnecte: true,
    },
  },
  ERREUR_PAGE_INDISPONIBLE: {
    siteUrl: '/compte/page-indisponible',
  },
  ERREUR_PROFIL: {
    siteUrl: '/erreur/profil',
  },

  // ***** Mon compte *****
  SECURITE_ET_MOT_DE_PASSE: {
    siteUrl: '/compte/securite-et-mot-de-passe',
    protection: {
      estConnecte: true,
    },
  },

  CANAFE_CONFIRMATION: {
    siteUrl: '/compte/mise-a-jour-informations-personnelles',
    protection: {
      estConnecte: true,
      aProfession: true,
      statusFlag: {
        listeAbsent: [playerPaymentProfileStatus.GUEST],
      },
    },
  },

  // ***** Club casino privilèges *****
  CLUB_CASINO_PRIVILEGES: {
    siteUrl: '/compte/club-casino-privileges',
    protection: {
      estConnecte: true,
      rafraichirProfile: true,
    },
  },

  // ***** BINGO *****
  BINGO_ACCUEIL: {
    siteUrl: '/bingo/accueil',
  },
  // ***** Bingo Lobby *****
  BINGO_LOBBY: {
    siteUrl: '/bingo/lobby',
    protection: {
      estConnecte: true,
    },
  },
  BINGO_SALLE: {
    siteUrl: '/bingo/salle',
  },
};

// siteUrl: Chemin physiquement défini dans Magnolia (indépendant de la langue)
// siteUrlEn: Chemin EN défini dans Magnolia
export const PageMappingCasino = {
  // ***** Début de l'inscription *****
  CASINO_ACCUEIL: {
    siteUrl: '/casino/accueil',
    siteUrlEn: '/casino/home',
  },
  CASINO_COLLECTION: {
    siteUrl: '/casino/c',
    siteUrlEn: '/casino/c',
  },
  CASINO_COLLECTION_JEU_FAVORI: {
    siteUrl: '/casino/c/favoris',
    siteUrlEn: '/casino/c/favourites',
  },
  CASINO_COLLECTION_JOUE_RECEMMENT: {
    siteUrl: '/casino/c/joues-recemment',
    siteUrlEn: '/casino/c/recently-played',
  },
  CASINO_PRODUIT: {
    siteUrl: '/casino/p',
    siteUrlEn: '/casino/p',
  },
  CASINO_PRODUIT_ATE: {
    siteUrl: '/casino/jeu',
    siteUrlEn: '/casino/game',
  },
  CASINO_MAS: {
    siteUrl: '/machines-a-sous',
    siteUrlEn: '/slot-machines',
  },
};

// URLs redirection dest avec connexion obligatoire (opl=1)
export const urlsDest = {
  fr: {
    autoexclusion: '/mon-compte/autoexclusion',
    'club-casino-privileges': PageMapping.CLUB_CASINO_PRIVILEGES.siteUrl,
    depot: PageMapping.DEPOT.siteUrl,
    'depot-credit': `${PageMapping.DEPOT.siteUrl}?onglet=credit-tab`,
    'depot-interac': `${PageMapping.DEPOT.siteUrl}?onglet=interac-tab`,
    'depot-argentWeb': `${PageMapping.DEPOT.siteUrl}?onglet=argentWeb-tab`,
    'depot-facture': `${PageMapping.DEPOT.siteUrl}?onglet=facture-tab`,
    detail: '/mon-compte/details-du-compte',
    documents: PageMapping.IDENTITE_DOCUMENTS.siteUrl,
    historique: '/mon-compte/historique-compte',
    'identite-reprise': PageMapping.IDENTITE_REPRISE.siteUrl,
    jeu: `${PageMappingCasino.CASINO_PRODUIT.siteUrl}${PageMappingCasino.CASINO_MAS.siteUrl}`,
    'jeu-ate': `${PageMappingCasino.CASINO_PRODUIT_ATE.siteUrl}${PageMappingCasino.CASINO_MAS.siteUrl}`,
    'lel-abonnements': '/lel/fr/mes-abonnements',
    'lel-achats': '/lel/fr/mes-achats',
    'lel-preferences-courriel': '/lel/fr/avis-par-courriel',
    'lel-favoris': '/lel/fr/mes-favoris',
    'lel-groupes': '/lel/fr/mes-groupes',
    'lel-jeux': '/fr/jeux',
    'limites-de-jeu': '/compte/limites-de-jeu',
    'limites-de-depot': '/compte/limites-de-jeu#limite-de-depot',
    'limites-de-temps': '/compte/limites-de-jeu#limite-de-temps',
    'limites-de-pertes': '/compte/limites-de-jeu#limite-de-pertes',
    'mon-compte': '/mon-compte/accueil',
    nousjoindre: '/pour-nous-joindre',
    'parties-en-cours': '/mon-compte/parties-en-cours',
    'pauses-de-jeu': '/mon-compte/pauses-de-jeu',
    'poker-pseudo': '/ok-poker/pseudo',
    promo: '/mon-compte/promotions',
    retrait: '/mon-compte/retraits',
    'securite-et-mot-de-passe': PageMapping.SECURITE_ET_MOT_DE_PASSE.siteUrl,
    // prettier-ignore
    'sommaire-de-mes-habitudes-de-jeu':
      '/compte/sommaire-de-mes-habitudes-de-jeu',
    'validation-identite': PageMapping.IDENTITE_REPRISE.siteUrl,
  },
  en: {
    autoexclusion: '/my-account/self-exclusion',
    'casino-privileges-club': PageMapping.CLUB_CASINO_PRIVILEGES.siteUrl,
    depot: PageMapping.DEPOT.siteUrl,
    'depot-credit': `${PageMapping.DEPOT.siteUrl}?onglet=credit-tab`,
    'depot-interac': `${PageMapping.DEPOT.siteUrl}?onglet=interac-tab`,
    'depot-argentWeb': `${PageMapping.DEPOT.siteUrl}?onglet=argentWeb-tab`,
    'depot-facture': `${PageMapping.DEPOT.siteUrl}?onglet=facture-tab`,
    detail: '/my-account/change-details',
    documents: PageMapping.IDENTITE_DOCUMENTS.siteUrl,
    historique: '/my-account/account-history',
    'identite-reprise': PageMapping.IDENTITE_REPRISE.siteUrl,
    jeu: `${PageMappingCasino.CASINO_PRODUIT.siteUrlEn}${PageMappingCasino.CASINO_MAS.siteUrlEn}`,
    'jeu-ate': `${PageMappingCasino.CASINO_PRODUIT_ATE.siteUrlEn}${PageMappingCasino.CASINO_MAS.siteUrlEn}`,
    'lel-abonnements': '/lel/en/my-subscriptions',
    'lel-achats': '/lel/en/my-purchases',
    'lel-preferences-courriel': '/lel/en/e-mail-notices',
    'lel-favoris': '/lel/en/my-favourites',
    'lel-groupes': '/lel/en/my-groups',
    'lel-jeux': '/en/games',
    'limites-de-jeu': '/account/gaming-limits',
    'limites-de-depot': '/account/gaming-limits#deposit-limit',
    'limites-de-temps': '/account/gaming-limits#time-limit',
    'limites-de-pertes': '/account/gaming-limits#loss-limit',
    'mon-compte': '/my-account/home',
    nousjoindre: '/contact-us',
    'parties-en-cours': '/my-account/games-in-progress',
    'pauses-de-jeu': '/my-account/pauses',
    'poker-pseudo': '/ok-poker/pseudo',
    promo: '/my-account/promotions',
    retrait: '/my-account/withdrawals',
    'securite-et-mot-de-passe': PageMapping.SECURITE_ET_MOT_DE_PASSE.siteUrl,
    'sommaire-de-mes-habitudes-de-jeu':
      '/account/summary-of-my-gambling-habits',
    'validation-identite': PageMapping.IDENTITE_REPRISE.siteUrl,
  },
};

export const PageMappingErreurSeveur = {
  404: {
    siteUrl: '/pages-inexistantes',
  },
};
